import countryTranslations from './countries';
import interfaceTranslations from './interface';
export { countryTranslations, interfaceTranslations };
export default Object.assign(Object.assign({}, countryTranslations), interfaceTranslations);
